import axios from "axios";
import RefreshTokenHandler from "../refreshToken/refreshToken";
import Config from "../config";

export const getChats = async (email, patient_id) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${
      Config.baseUrl
    }/chat/patient-id?email=${email}&patient_id=${patient_id}&page_size=${100}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getChats(email, patient_id);
      } else {
        throw err.response;
      }
    } else {
      throw err.response;
    }
  }
};
